/**
 * Ajusta una fila de tabla de pdfMake al numero real de columnas declaradas.
 *
 * Las tablas de conceptos arman sus `widths` con spreads condicionales
 * (ocultarColumnaIVA, imprimirIEPS, ocultarColumnaPU, etc.) y cada fila tiene
 * que repetir exactamente los mismos gates. Si una fila emite una celda de mas,
 * pdfMake no truena al medir (solo mide hasta `body[0].length`) pero si al
 * pintar: `layoutBuilder` recorre la fila y hace `widths[i]._calcWidth`, que
 * con `widths[i] === undefined` revienta el documento completo con
 * "Cannot read properties of undefined (reading '_calcWidth')".
 *
 * Este candado convierte ese desajuste en una celda vacia o en una celda
 * recortada, para que el PDF siga abriendo.
 */
export const normalizarFilaTabla = (fila, totalCols) => {
  if (!Array.isArray(fila) || !Number.isFinite(totalCols) || totalCols <= 0) return fila;
  if (fila.length === totalCols) return fila;
  if (fila.length > totalCols) return fila.slice(0, totalCols);
  // Objetos nuevos por celda: pdfMake muta las celdas al medir (_span, _minWidth, _maxWidth)
  return [
    ...fila,
    ...Array.from({ length: totalCols - fila.length }, () => ({ text: "" })),
  ];
};

export default normalizarFilaTabla;
